import { render, staticRenderFns } from "./DocumentActionDropdown.vue?vue&type=template&id=51041a3b&"
import script from "./DocumentActionDropdown.vue?vue&type=script&lang=ts&"
export * from "./DocumentActionDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports